import React from 'react';
import { Alert } from '../Alert';

export const FormError = props => (
  <Alert color="danger" toggle={props.clear}>
    {props.error}
  </Alert>
);
